import {createFlexPuffSetting} from './createFlexPuffSetting';

const {ButtonComponent: FlexPuffButton} = createFlexPuffSetting();

export default FlexPuffButton;
